export default {
  title: 'Modelos de Referência',
  createButton: 'Criar Modelo de Referência',
  searchLabel: 'Buscar',
  headers: {
    categoryName: 'Nome da Categoria',
    codename: 'Código',
    pkl: 'PKL',
    pklSize: 'Tamanho PKL',
    modified: 'Modificado',
    actions: 'Ações',
    disabled: 'Desabilitado',
    status: 'Status'
  },
  tooltips: {
    edit: 'Editar Modelo de Referência',
    delete: 'Excluir Modelo de Referência',
    updateCustomModels: 'Atualizar Modelos Personalizados existentes'
  },
  deleteDialog: {
    title: 'Aviso',
    message: 'Excluindo Modelo de Referência:',
    confirmation: 'Esta ação não pode ser desfeita. Tem certeza?',
    cancel: 'Cancelar',
    delete: 'Excluir'
  },
  updateDialog: {
    title: 'Aviso',
    message: 'Atualizando Modelos Personalizados existentes para o Modelo de Referência:',
    confirmation: 'Esta ação não pode ser desfeita. Tem certeza?',
    cancel: 'Cancelar',
    update: 'Atualizar'
  }
}
